import colors from '@kiper/theme/colors';
import { buildMapsUrl, formatDate } from '@kiper/fns';
import { PERSONALIZED_INVITE_BY_CONDOMINIUM } from '../settings';
import bannerPorterInvite from '../../../../assets/images/banner-porter-invite.png';
import logoPorter from '../../../../assets/images/logo-porter.svg';

export const adaptInviteGuestToPersonalizedInvite = inviteGuestData => {
  if (!inviteGuestData) return null;

  const {
    id,
    hashId,
    invite,
    condominium,
    unity,
    unityGroup,
    address,
    hasFaceId,
    customBannerUrl,
    customPorterUrl,
    guestName,
    hasSmartLock,
    condominiumPersonContextId,
  } = inviteGuestData;

  const condominiumInvite =
    PERSONALIZED_INVITE_BY_CONDOMINIUM[condominiumPersonContextId];

  const formatEventDate = start => {
    const dateToFormat = start;
    if (!dateToFormat) return null;

    return formatDate(dateToFormat, 'L - HH:mm').formatted;
  };

  const formatAddress = (addr, condo) => {
    if (!addr && !condo) return '';

    const parts = [];
    if (addr?.streetName) parts.push(addr.streetName);
    if (addr?.addressNumber) parts.push(addr.addressNumber);
    if (addr?.additionalInfo) parts.push(addr.additionalInfo);

    return parts.join(', ');
  };

  const formatDestination = (un, group) => {
    const parts = [];
    if (group?.name) parts.push(group.name);
    if (un?.name) parts.push(un.name);
    return parts.join(' - ') || '';
  };

  const formattedAddress = formatAddress(address, condominium);

  return {
    id: id || hashId,
    guestId: id,
    inviteTitle: invite?.name || '',
    eventDate: formatEventDate(invite?.start),
    eventEndDate: formatEventDate(invite?.end),
    location: {
      name: condominium?.name || '',
      address: formattedAddress,
      mapsUrl: buildMapsUrl(formattedAddress),
    },
    destination: formatDestination(unity, unityGroup),
    customization: {
      primaryColor: colors.porterSecondary,
      secondaryColor: colors.porterPrimary,
      logoUrl: customPorterUrl || logoPorter,
      bannerImageUrl: customBannerUrl || bannerPorterInvite,
      ...condominiumInvite?.customization,
    },
    hostMessage: condominiumInvite?.hostMessage || null,
    condominiumNotice: condominiumInvite?.condominiumNotice || null,
    hasFacialRegistered: hasFaceId || false,
    facialPhoto: null,
    userName: guestName || null,
    hasSmartLock: !!hasSmartLock,
  };
};

export const adaptInviteGuestQueryData = queryData => {
  if (!queryData) {
    return {
      data: null,
      loading: false,
      error: null,
    };
  }

  const { data, loading, error } = queryData;
  const inviteGuestData = data?.getInviteGuest;

  return {
    data: adaptInviteGuestToPersonalizedInvite(inviteGuestData),
    loading,
    error,
  };
};

export const isInviteExpired = inviteData => {
  if (!inviteData?.invite?.end) return false;
  const endDate = new Date(inviteData.invite.end);
  return endDate < new Date();
};

export const isInviteValid = inviteData => {
  if (!inviteData) return false;
  return !!(inviteData.id || inviteData.hashId);
};
